import './App.css';
import './index.css';
import { Routes, Route } from "react-router-dom";
import Home from './Views/Home'
import Electronics from "./Views/Electronics";
import Clothing from "./Views/Cloth";
import Furniture from "./Views/Furniture";
import Autopart from "./Views/Autopart";
import Tea from "./Views/Tea";
import { Provider } from 'react-redux';
import {Store } from './Redux/Store';
import { ChakraProvider } from '@chakra-ui/react'
import Cartpage from './Views/Cart';
import Userprofile from './Views/Profile';
import Aboutus from './Views/About/aboutus';
import Contactus from './Views/Contact';
import OrderDetails from './Views/OrderDetails'
import Products from './Views/Products';
import Terms from './Views/Terms'
import RefundPolicy from './Views/RefundPolicy'
import PrivacyPolicy from './Views/PrivacyPolicy'
import ThankYou from './Views/ThankYou';

function App() {
  return (
    <Provider store={Store}>
      <ChakraProvider>
        <div className="App">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/cart" element={<Cartpage />} />
            <Route path="/profile" element={<Userprofile />} />
            <Route path="/about-us" element={<Aboutus />} />
            <Route path="/contact-us" element={<Contactus />} />
            <Route path="/products" element={<Products />} />
            <Route path="/order/:id" element={<OrderDetails />} />
            <Route path="/terms-conditions" element={<Terms />} />
            <Route path="/refund-policy" element={<RefundPolicy />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/success" element={<ThankYou />} />

          </Routes>
        </div>
      </ChakraProvider>
    </Provider>
  );
}

export default App;
